import { useState, useRef, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import TopTeams from "../Components/TopTeams";
import Config from "../../Utility/Config";
import Utility from "../../Utility/Utility";

import {
    getPlayerListApi,
    getCoachListApi,
    createTeamApi,
} from "../Team/TeamController";
import { getSponserListApi, getTournamenTypeListApi, createTournamentApi } from "./TournamentController"
import { imageUploadApi, getCountryApi } from "../../Login/Controller/LoginController";
import { loaderStateTrue, loaderStateFalse } from "../../slices/mainSlice";


const CreateTournament = () => {

    const { t, i18n } = useTranslation();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { language } = useSelector((state) => state.language);
    const { userDetails, token, userType } = useSelector((state) => state.user);

    const [openCountry, setOpenCountry] = useState(false);
    const [openTournamentType, setOpenTournamentType] = useState(false);
    const [selectedCountry, setSelectedCountry] = useState("");
    const [selectedTournamentType, setSelectedTournamentType] = useState("");
    const countryRef = useRef(null);
    const tournamentTypeRef = useRef(null);

    const [playerList, setPlayerList] = useState([]);
    const [tournamentTypeList, setTournamentTypeList] = useState([]);
    const [countries, setCountryList] = useState([]);
    const [sponserList, setSponserList] = useState([]);
    const [teamsPlayer, setTeamsPlayer] = useState([]);
    const [selectedPlayer, setSelectedPlayer] = useState("VIRAT");
    const [openPlayer, setOpenPlayer] = useState(false);
    console.log("playerListplayerListplayerList", playerList);

    useEffect(() => {
        getCountryList();
        getSponserList();
        getTournamentTypeList();
    }, []);

    const getCountryList = () => {
        try {
            dispatch(loaderStateTrue());
            getCountryApi()
                .then((response) => {
                    let responseData = response.data || [];
                    setCountryList(responseData);
                    dispatch(loaderStateFalse());
                })
                .catch((error) => {
                    console.log(error);
                    dispatch(loaderStateFalse());
                });
        } catch (error) {
            console.log(error);
            dispatch(loaderStateFalse());
        }
    };

    const getSponserList = () => {
        try {
            dispatch(loaderStateTrue());
            getSponserListApi()
                .then((response) => {
                    let responseData = response.data || [];
                    setSponserList(responseData);
                    dispatch(loaderStateFalse());
                })
                .catch((error) => {
                    console.log(error);
                    dispatch(loaderStateFalse());
                });
        } catch (error) {
            console.log(error);
            dispatch(loaderStateFalse());
        }
    };

    const getTournamentTypeList = () => {
        try {
            dispatch(loaderStateTrue());
            getTournamenTypeListApi()
                .then((response) => {
                    let responseData = response.data || [];
                    setTournamentTypeList(responseData);
                    dispatch(loaderStateFalse());
                })
                .catch((error) => {
                    console.log(error);
                    dispatch(loaderStateFalse());
                });
        } catch (error) {
            console.log(error);
            dispatch(loaderStateFalse());
        }
    };

    useEffect(() => {
        const handler = (e) => {
            if (countryRef.current && !countryRef.current.contains(e.target)) {
                setOpenCountry(false);
            }
        };

        document.addEventListener("mousedown", handler);
        return () => document.removeEventListener("mousedown", handler);
    }, []);

    const activeCountry = countries.find((c) => c._id === selectedCountry);

    useEffect(() => {
        const handler = (e) => {
            if (tournamentTypeRef.current && !tournamentTypeRef.current.contains(e.target)) {
                setOpenTournamentType(false);
            }
        };

        document.addEventListener("mousedown", handler);
        return () => document.removeEventListener("mousedown", handler);
    }, []);

    const activeTournamentType = tournamentTypeList.find((c) => c._id === selectedTournamentType);

    const [isOpen, setIsOpen] = useState(false);
    const [selected, setSelected] = useState([]);

    const dropdownRef = useRef(null);

    // ==== Outside Click Handler ====
    useEffect(() => {
        const handleClickOutside = (e) => {
            if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
                setIsOpen(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const handleSelect = (item) => {
        if (!selected.some((s) => s._id === item._id)) {
            setSelected([...selected, item]);
        }
        setIsOpen(false);
    };

    const handleRemove = (_id) => {
        setSelected(selected.filter((s) => s._id !== _id));
    };

    const handleSelectPlayer = (element) => {
        if (!element) {
            setTournamentError((prev) => ({
                ...prev,
                sponsor: "Please select a sponser",
            }));
            return;
        }

        setTeamsPlayer((prev) => [...prev, element]);
        setPlayerList((prev) => prev.filter((player) => player.id !== element.id));
        setTournamentData((prev) => ({
            ...prev,
            sponsor: [...(prev.sponsor || []), element.id],
        }));
        setTournamentError((prev) => ({ ...prev, sponsor: "" }));
        setOpenPlayer(false);
        setSelectedPlayer(element.id);
    };
    console.log("selectedselectedselectedselected", selected)
    const sponsor = selected.map(item => item._id);
    console.log("sponsorsponsorsponsorsponsor", sponsor)


    const [tournamentData, setTournamentData] = useState({
        name: "",
        tournamentType: "",
        country: "",
        sponsor: sponsor,
        bannerImage: "https://jogastar.mydevnxerra.com/uploads/1764667780463-502083139.jpg",
        shortName: "",
        numberOfTeams: "",
        numberOfRounds: "",
        startDate: "",
        endDate: "",
        venue: "",
    });

    const [tournamentError, setTournamentError] = useState({
        name: "",
        tournamentType: "",
        country: "",
        sponsor: [],
        bannerImage: "",
        shortName: "",
        numberOfTeams: "",
        numberOfRounds: "",
        startDate: "",
        endDate: "",
        venue: "",
    });

    const validateLogin = () => {
        let valid = true;
        if (tournamentData.name.trim() === "") {
            valid = false;
            setTournamentError({ ...tournamentError, name: t("requiredField") });
        } else {
            setTournamentError({ ...tournamentError, name: "" });
        }
        if (tournamentData.tournamentType.trim() === "") {
            valid = false;
            setTournamentError({ ...tournamentError, tournamentType: t("requiredField") });
        } else {
            setTournamentError({ ...tournamentError, tournamentType: "" });
        }
        if (tournamentData.country.trim() === "") {
            valid = false;
            setTournamentError({ ...tournamentError, country: t("requiredField") });
        } else {
            setTournamentError({ ...tournamentError, country: "" });
        }
        return valid;
    };

    const handleCreate = () => {
        let valid = validateLogin();
        if (valid) {
            let data = {
                ...tournamentData,
                sponsor: selected.map(item => item._id)
            };
            dispatch(loaderStateTrue());
            createTournamentApi(data)
                .then(async (response) => {
                    console.log("responseresponseresponseresponse", response)
                    if (response.status) {
                        setTimeout(() => {
                            dispatch(loaderStateFalse());
                            navigate(`/${language}/dashboard`);
                        }, 1000);
                        Utility.toastNotifications(response.message, "Success", "success");
                    } else {
                        dispatch(loaderStateFalse());
                        Utility.toastNotifications(response.message, "Error", "error");
                    }
                })
                .catch((error) => {
                    console.log(error);
                    Utility.toastNotifications(
                        error.response.data.message,
                        "Error",
                        "error"
                    );
                    if (error.response.status === 401) {
                        Utility.toastNotifications(
                            error.response.data.message,
                            "Error",
                            "error"
                        );
                    }
                    dispatch(loaderStateFalse());
                });
        }
    };

    const handleImageUpload = (file) => {
        dispatch(loaderStateTrue());
        imageUploadApi(file)
            .then((response) => {
                if (response.status) {
                    console.log("responseresponseresponse", response)
                    setTournamentData((prev) => ({
                        ...prev,
                        bannerImage: response.data?.url || "",
                    }));
                    dispatch(loaderStateFalse());
                    Utility.toastNotifications(response.message, "Success", "success");
                } else {
                    dispatch(loaderStateFalse());
                    Utility.toastNotifications(response.message, "Error", "error");
                }
            })
            .catch((error) => {
                dispatch(loaderStateFalse());
                Utility.toastNotifications("Upload failed", "Error", "error");
            });
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        setTournamentData((prev) => ({
            ...prev,
            [name]: value,
        }));

        setTournamentError((prev) => ({
            ...prev,
            [name]: "",
        }));
    };


    return (
        <main class="main p-4 relative">
            <div class="flex flex-col">
                <div class="flex flex-wrap items-start gap-y-6 -mx-2">
                    <div class="lg:w-4/6 w-full px-2">
                        <div className="space-y-5">
                            <div className="relative">
                                <div className="relative rounded-xl bg-gray-50 h-full">
                                    <div className='absolute inset-0 rounded-xl overflow-hidden'>
                                        <div className="w-[8vw] h-[8vw] rounded-[50%] bg-[#F022AC] blur-[80px] absolute -top-[1vw] -right-[2vw] opacity-80"></div>
                                        <div className="w-[16vw] h-[16vw] rounded-[50%] bg-[#FB4A4A] blur-[80px] absolute -top-[6vw] right-[5vw]"></div>
                                        <div className="w-[10vw] h-[10vw] rounded-[50%] bg-[#0198FF] blur-[100px] absolute -bottom-[6vw] right-[15vw]"></div>
                                    </div>
                                    <div className="flex max-sm:flex-wrap gap-3 justify-between relative">
                                        <div className="p-5 flex flex-col items-start justify-center [&_h1_strong]:text-primary-500 space-y-3 [&_strong]:text-primary-500">
                                            <div className="space-y-2">
                                                <h2 className="lg:text-4xl md:text-3xl text-xl font-black uppercase">Create a new Tournament</h2>
                                                <p className='text-base font-medium text-gray-400'>Dummy text of the printing and typesetting industry.</p>
                                            </div>
                                        </div>
                                        <div className="lg:-mt-4 text-center">
                                            <img src="assets/images/football-stadium2.png" alt="" className="w-full inline-block rounded-br-xl" />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="flex flex-wrap gap-y-4 -mx-2">
                                <div className="xs:w-1/2 w-full px-2">
                                    <label className="form-label">{t('tournamentName')}</label>
                                    <input
                                        type="text"
                                        id="name"
                                        placeholder="Tournament Name"
                                        className="form-control"
                                        onChange={(e) => {
                                            setTournamentData({ ...tournamentData, name: e.target.value });
                                            setTournamentError({ ...tournamentError, name: "" });
                                        }}
                                        value={tournamentData.name}
                                    />
                                    <span className="text-red-500">{tournamentError.name}</span>
                                </div>
                                <div className="xs:w-1/2 w-full px-2">
                                    <label className="form-label">{t('tournamentType')}</label>
                                    <div className="dropdown border rounded-lg bg-white relative">
                                        <div className="relative z-[1]" ref={tournamentTypeRef}>
                                            <button
                                                className="flex items-center gap-2 px-4 py-2.5 w-full cursor-pointer"
                                                onClick={() => setOpenTournamentType(!openTournamentType)}
                                            >
                                                <span>{activeTournamentType?.name}</span>
                                                <img
                                                    src="assets/images/icons/arrow-chevron-downward.svg"
                                                    className={`ml-auto transition-transform ${openTournamentType ? "rotate-180" : ""
                                                        }`}
                                                    alt=""
                                                />
                                            </button>
                                            <div
                                                className={`absolute w-full bg-white shadow-lg border rounded-lg max-h-64 overflow-auto transition-all
                                        ${openTournamentType
                                                        ? "opacity-100 visible scale-100"
                                                        : "opacity-0 invisible scale-95"
                                                    }`}
                                            >
                                                <ul>
                                                    {tournamentTypeList.map((item, index) => (
                                                        <li
                                                            key={index}
                                                            className={`px-4 py-2 flex items-center gap-2 cursor-pointer hover:bg-gray-100 
                                                ${selectedTournamentType === item.name
                                                                    ? "bg-gray-200 font-semibold"
                                                                    : ""
                                                                }`}
                                                            onClick={() => {
                                                                setSelectedTournamentType(item._id);
                                                                setTournamentData({
                                                                    ...tournamentData,
                                                                    tournamentType: item._id,
                                                                });
                                                                setTournamentError({ ...tournamentError, tournamentType: "" });
                                                                setOpenTournamentType(false);
                                                            }}
                                                        >
                                                            {item?.name}
                                                        </li>
                                                    ))}
                                                </ul>
                                            </div>
                                            <span className="text-red-500">{tournamentError?.tournamentType}</span>
                                        </div>
                                    </div>
                                    <span className="text-red-500"></span>
                                </div>
                                <div className="xs:w-1/2 w-full px-2">
                                    <label className="form-label">{t('startDate')}</label>
                                    <input
                                        type="date"
                                        id=""
                                        name="startDate"
                                        placeholder="Select Date"
                                        className="form-control"
                                        onChange={handleInputChange}
                                        value={tournamentData?.startDate}
                                    />
                                    <span className="text-red-500">{tournamentError?.startDate}</span>
                                </div>
                                <div className="xs:w-1/2 w-full px-2">
                                    <label className="form-label">{t('endDate')}</label>
                                    <input
                                        type="date"
                                        id=""
                                        name="endDate"
                                        placeholder="Select Date"
                                        className="form-control"
                                        onChange={handleInputChange}
                                        value={tournamentData?.name}
                                    />
                                    <span className="text-red-500">{tournamentError.endDate}</span>
                                </div>
                                <div className="xs:w-1/2 w-full px-2">
                                    <label className="form-label">{t('venue')}</label>
                                    <input
                                        type="text"
                                        id=""
                                        name="venue"
                                        placeholder="Enter a Venue"
                                        className="form-control"
                                        onChange={handleInputChange}
                                        value={tournamentData?.venue}
                                    />
                                    <span className="text-red-500">{tournamentError.venue}</span>
                                </div>
                                <div className="xs:w-1/2 w-full px-2">
                                    <label className="form-label">{t('country')}</label>
                                    <div className="dropdown border rounded-lg bg-white relative">
                                        <div className="relative z-[1]" ref={countryRef}>
                                            <button
                                                className="flex items-center gap-2 px-4 py-2.5 w-full cursor-pointer"
                                                onClick={() => setOpenCountry(!openCountry)}
                                            >
                                                <img
                                                    src={activeCountry?.flag}
                                                    className="size-6 rounded-full"
                                                    alt=""
                                                />
                                                <span>{activeCountry?.name}</span>

                                                <img
                                                    src="assets/images/icons/arrow-chevron-downward.svg"
                                                    className={`ml-auto transition-transform ${openCountry ? "rotate-180" : ""
                                                        }`}
                                                    alt=""
                                                />
                                            </button>
                                            <div
                                                className={`absolute w-full bg-white shadow-lg border rounded-lg max-h-64 overflow-auto scrollbar-custom transition-all
                                        ${openCountry
                                                        ? "opacity-100 visible scale-100"
                                                        : "opacity-0 invisible scale-95"
                                                    }`}
                                            >
                                                <ul>
                                                    {countries.map((item, index) => (
                                                        <li
                                                            key={index}
                                                            className={`px-4 py-2 flex items-center gap-2 cursor-pointer hover:bg-gray-100 
                                                ${selectedCountry === item._id
                                                                    ? "bg-gray-200 font-semibold"
                                                                    : ""
                                                                }`}
                                                            onClick={() => {
                                                                setSelectedCountry(item._id);
                                                                setTournamentData({
                                                                    ...tournamentData,
                                                                    country: item._id,
                                                                });
                                                                setTournamentError({ ...tournamentError, country: "" });
                                                                setOpenCountry(false);
                                                            }}
                                                        >
                                                            <img src={item.flag} className="size-6 object-cover rounded-full" alt="" />
                                                            {item.name}
                                                        </li>
                                                    ))}
                                                </ul>
                                            </div>
                                            <span className="text-red-500">{tournamentError?.country}</span>
                                        </div>
                                    </div>
                                </div>

                                <div className="xs:w-full w-full px-2">
                                    <label className="form-label">{t('addSponsor')}</label>
                                    <div className="w-full relative" ref={dropdownRef}>
                                        <div className="border px-4 py-2.5 rounded-md cursor-pointer bg-white"
                                            onClick={() => setIsOpen(!isOpen)}
                                        >
                                            <span className="font-medium">Select sponsor...</span>
                                        </div>
                                        {isOpen && (
                                            <div className="absolute z-20 mt-1 bg-white border rounded-lg shadow-lg w-full max-h-56 overflow-auto">
                                                {sponserList.map((item) => (
                                                    <div
                                                        key={item.id}
                                                        className="flex items-center gap-3 p-2 hover:bg-gray-100 cursor-pointer"
                                                        onClick={() => handleSelect(item)}
                                                    >
                                                        <img src={item?.photo} alt="" className="w-6 h-6 object-contain" />
                                                        <span className="font-medium">{item?.fullName}</span>
                                                    </div>
                                                ))}
                                            </div>
                                        )}
                                        <div className="flex gap-2 mt-3 flex-wrap">
                                            {selected.map((item) => (
                                                <div
                                                    key={item.id}
                                                    className="flex items-center gap-2 bg-gray-100 px-3 py-1 rounded-full"
                                                >
                                                    <img src={item?.photo} alt="" className="w-5 h-5 object-contain" />
                                                    <span>{item?.fullName}</span>
                                                    <button
                                                        className="text-red-500 font-bold"
                                                        onClick={() => handleRemove(item.id)}
                                                    >
                                                        &times;
                                                    </button>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                                <div className="w-full px-2">
                                    <div className="flex items-center justify-center w-full">
                                        <label
                                            for="dropzone-file"
                                            className="flex flex-col items-center justify-center w-full h-48 bg-neutral-secondary-medium border-2 border-dashed border-default-strong border-gray-200 rounded-xl cursor-pointer hover:bg-neutral-tertiary-medium"
                                        >
                                            <div className="flex flex-col items-center justify-center text-body pt-5 pb-6">
                                                <div className="bg-gradient-to-r from-primary-500 via-primary-700 to-primary-950 text-white rounded-full p-1 size-8 flex justify-center items-center">
                                                    <img
                                                        src="assets/images/icons/plus.svg"
                                                        alt=""
                                                        className="icon-white flex-none size-full"
                                                    />
                                                </div>
                                                <label className="my-2 uppercase">
                                                    <span className="font-semibold">Add a Banner</span>
                                                </label>
                                                <p className="font-medium text-gray-400">Drag and drop your documents to get started.</p>
                                            </div>
                                            <input
                                                id="dropzone-file"
                                                type="file"
                                                className="hidden"
                                                onChange={(e) => handleImageUpload(e.target.files[0])}
                                            />
                                        </label>
                                    </div>
                                </div>

                                <div className="xs:w-1/2 w-full px-2">
                                    <label className="form-label">{t('numberTeams')}</label>
                                    <select name="numberOfTeam" id="numberOfTeam" className='form-select'
                                        onChange={handleInputChange}
                                    >
                                        <option value="">Select Team</option>
                                        <option value="8">8</option>
                                        <option value="16">16</option>
                                        <option value="24">24</option>
                                        <option value="32">32</option>
                                        <option value="48">48</option>
                                    </select>
                                    <span className="text-red-500">{tournamentError?.numberOfTeams}</span>
                                </div>

                                <div className="xs:w-1/2 w-full px-2">
                                    <label className="form-label">{t('numberRounds')}</label>
                                    <select name="numberOfRounds" id="numberOfRounds" className='form-select'
                                        onChange={handleInputChange}
                                    >
                                        <option value="">Select Round</option>
                                        <option value="4">4</option>
                                        <option value="8">8</option>
                                        <option value="16">16</option>
                                    </select>
                                    <span className="text-red-500">{tournamentError?.numberOfRounds}</span>
                                </div>
                            </div>
                            <div className="flex flex-wrap items-start gap-4 p-3 rounded-lg bg-gray-50">
                                <div>
                                    <h3 className="text-lg font-extrabold uppercase">Notes</h3>
                                    <p className="text-gray-400">Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>
                                </div>
                                <button
                                    className="btn btn-primary text-nowrap ml-auto"
                                    // onClick={() => navigate("/en/team-management")}
                                    onClick={handleCreate}
                                >
                                    Proceed
                                </button>
                            </div>
                        </div>
                    </div>
                    <div className="lg:w-2/6 w-full px-2 sticky top-20">
                        <div className="space-y-5">
                            <div className="relative">
                                <div className="rounded-xl absolute inset-0 bg-[#F8F8F8] overflow-hidden">
                                    <div className="absolute -skew-x-[20deg] w-[4vw] top-0 -left-12 bottom-0 bg-[#3D54AC]"></div>
                                    <div className="absolute -skew-x-[20deg] w-[18vw] top-0 -right-12 bottom-0 bg-[#3D54AC] before:content-[''] before:absolute before:w-2/3 before:top-0 before:left-0 before:bottom-0 before:bg-black/10"></div>
                                </div>
                                <div className="relative bg-cover bg-no-repeat bg-center h-full">
                                    <div className="flex lg:justify-center justify-center max-sm:flex-wrap gap-y-3 w-full">
                                        <div className="flex-none max-sm:w-1/2 max-lg:w-1/3 lg:-mt-4 relative">
                                            <img src="assets/images/teams.png" alt="" className="max-w-full lg:max-h-[276px] inline-block" />
                                        </div>
                                    </div>
                                    <div className="absolute left-0 bottom-0 right-0 p-4 flex justify-between items-center gap-6 bg-gradient-to-t from-[#3D54AC] rounded-b-xl overflow-hidden">
                                        <div className="">
                                            <div className="space-y-2">
                                                <h4 className="lg:text-2xl md:text-xl text-lg font-black leading-none uppercase text-white">{t('createTeam')}</h4>
                                            </div>
                                        </div>
                                        <div className="">
                                            <button className="btn btn-primary text-nowrap ml-auto" onClick={() => navigate(`/${language}/create-team`)}>{t('seeAll')}</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    )
}

export default CreateTournament